import { FC } from 'react';

import { MediaListItem } from 'application/components/MediaList/MediaListItem';
import { MediaListItemIconsUploader } from 'application/components/MediaList/MediaListItemIcons';
import FileUtils from 'application/utils/FileUtils';

import IconGripVertical from '@zvuk-b2b/react-uikit/ui/icons/GripVertical';

import { ELEMENT_IDS, MEDIA_FILE_TYPE } from '../consts';
import styles from '../index.module.scss';
import { SortableAudioUploaderItemProps } from '../types';

const SortableAudioUploaderItem: FC<SortableAudioUploaderItemProps> = ({
  item,
  player,
  onPlayClick,
  onRemoveClick,
  onRetryClick,
}) => {
  const itemId = item.id || '';
  const filename = item.file?.name || item.title || item.filename || '';
  const fileUrl = FileUtils.getMediafileUrl(item.sourcefiles) || '';
  const isMediafilePlaying = player.fileName === filename && player.fileUuid === itemId;
  const mediaFileProgress = isMediafilePlaying ? player.progress : undefined;
  const isRemoveVisible = !item.error && !item.isLoading && itemId;

  return (
    <li className={styles.item}>
      <span
        className={styles.dragHandle}
        data-testid={`${ELEMENT_IDS.dragHandlePrefix}_${itemId || filename}`}>
        <IconGripVertical />
      </span>
      <MediaListItem
        title={filename}
        isLoading={item.isLoading}
        isPaused={player.isPaused}
        isMediafilePlaying={isMediafilePlaying}
        progress={mediaFileProgress}
        type={MEDIA_FILE_TYPE}
        className={styles.mediaItem}
        titleClassName={styles.mediaItemTitle}
        progressSliderClassName={styles.progressSlider}
        onClickPlay={() => onPlayClick(itemId, filename, fileUrl)}
        onClickPause={player.pause}
        onClickResume={player.resume}
        onChangeProgress={player.changeProgress}>
        <MediaListItemIconsUploader
          id={`${ELEMENT_IDS.mediaIconsPrefix}_${itemId}`}
          isRemove={Boolean(isRemoveVisible)}
          isError={Boolean(item.error)}
          isMultiple
          onRemove={() => onRemoveClick(itemId)}
          onRetry={() => onRetryClick(itemId)}
        />
      </MediaListItem>
    </li>
  );
};

export default SortableAudioUploaderItem;
